import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ASSETS } from "./Decorative";
import { Mail, Phone, MapPin, Instagram, Facebook, MessageCircle } from "lucide-react";

export const Footer = () => {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        api.get("/site-info").then((r) => setInfo(r.data)).catch(() => {});
    }, []);

    const socials = [
        { url: info?.facebook, icon: Facebook, label: "Facebook" },
        { url: info?.instagram, icon: Instagram, label: "Instagram" },
        { url: info?.whatsapp, icon: MessageCircle, label: "WhatsApp" },
    ].filter((s) => s.url);

    return (
        <footer className="bg-deep-green text-cream mt-24" data-testid="main-footer">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-12">
                <div>
                    <div className="flex items-center gap-3 mb-4">
                        <img src={ASSETS.mascot} alt="Eistroll" className="w-14 h-14 object-contain" />
                        <div>
                            <div className="font-serif text-2xl font-semibold">Softeis Garten</div>
                            <div className="font-cursive text-xl text-pastel-pink">~ schöne Eis-Momente ~</div>
                        </div>
                    </div>
                    <p className="text-cream/70 text-sm leading-relaxed max-w-sm">
                        Frisches Softeis, gemütlicher Garten – ein kleiner Ort zum Genießen mit der ganzen Familie.
                    </p>
                    {socials.length > 0 && (
                        <div className="flex gap-3 mt-5">
                            {socials.map(({ url, icon: Icon, label }) => (
                                <a
                                    key={label}
                                    href={url}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label={label}
                                    title={label}
                                    className="w-10 h-10 grid place-items-center rounded-full bg-cream/10 hover:bg-pastel-pink hover:text-deep-green transition"
                                    data-testid={`footer-${label.toLowerCase()}`}
                                >
                                    <Icon className="w-4 h-4" />
                                </a>
                            ))}
                        </div>
                    )}
                </div>

                <div>
                    <h4 className="font-serif text-lg mb-4 text-cream">Kontakt</h4>
                    <ul className="space-y-3 text-sm text-cream/80">
                        {info?.address && (
                            <li className="flex items-start gap-3" data-testid="footer-address">
                                <MapPin className="w-4 h-4 mt-0.5 text-leaf-green flex-shrink-0" />
                                <span>{info.address}</span>
                            </li>
                        )}
                        {info?.phone && (
                            <li className="flex items-center gap-3" data-testid="footer-phone">
                                <Phone className="w-4 h-4 text-leaf-green" />
                                <a href={`tel:${info.phone}`} className="hover:text-pastel-pink">{info.phone}</a>
                            </li>
                        )}
                        {info?.email && (
                            <li className="flex items-center gap-3" data-testid="footer-email">
                                <Mail className="w-4 h-4 text-leaf-green" />
                                <a href={`mailto:${info.email}`} className="hover:text-pastel-pink">{info.email}</a>
                            </li>
                        )}
                    </ul>
                </div>

                <div>
                    <h4 className="font-serif text-lg mb-4 text-cream">Mehr</h4>
                    <ul className="space-y-2 text-sm text-cream/80">
                        <li><Link to="/speisekarte" className="hover:text-pastel-pink">Unser Angebot</Link></li>
                        <li><a href="/#heute" className="hover:text-pastel-pink">Heutiges Softeis</a></li>
                        <li><a href="/#fuer-spaeter" className="hover:text-pastel-pink">Für Später</a></li>
                        <li><a href="/#galerie" className="hover:text-pastel-pink">Galerie</a></li>
                        <li>
                            <Link to="/impressum" className="hover:text-pastel-pink" data-testid="footer-impressum-link">
                                Impressum
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/login" className="hover:text-pastel-pink text-cream/50" data-testid="footer-admin-link">
                                Admin
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-cream/10">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-cream/50 flex justify-between items-center">
                    <span>© {new Date().getFullYear()} Softeis Garten. Alle Rechte vorbehalten.</span>
                    <span className="font-cursive text-base text-pastel-pink/80">made with ♥</span>
                </div>
            </div>
        </footer>
    );
};
